import { __awaiter } from "tslib";
import { Cookies } from 'react-cookie';
import { META_DATA_KEY } from '../utils/constants';
class ApiError extends Error {
    constructor(result, httpStatus) {
        super((result === null || result === void 0 ? void 0 : result.message) || 'API Error');
        // Spread all result properties first for backward compatibility
        Object.assign(this, result);
        this.name = 'ApiError';
        // HTTP status code available via httpStatus
        this.httpStatus = httpStatus;
        // Ensure code is set for backward compatibility
        if (this.code === undefined) {
            this.code = httpStatus;
        }
    }
}
const METADATA_HEADER = 'x-metadata';
const cookies = new Cookies();
const CSRF_HEADER = {
    _csrf: {
        toString() {
            return cookies.get('_csrf');
        },
    },
    'x-xsrf-token': {
        toString() {
            return cookies.get('XSRF-TOKEN');
        },
    },
};
const DEFAULT_HEADERS = Object.assign({ 'X-Version': WEB_PLUGIN_VERSION, [METADATA_HEADER]: {
        toString() {
            return sessionStorage.getItem(META_DATA_KEY);
        },
    }, 'Content-Type': 'application/json' }, CSRF_HEADER);
class AjaxUtils {
    patch(route_1, data_1) {
        return __awaiter(this, arguments, void 0, function* (route, data, isFullUrl = false) {
            const options = {
                method: 'PATCH',
                credentials: 'include',
                mode: 'cors',
                headers: Object.assign({}, DEFAULT_HEADERS),
                body: JSON.stringify(data),
            };
            const url = isFullUrl ? new URL(route) : new URL(envConfig.OUTBOUND_SERVER_URL + route);
            const request = new Request(url.toString(), options);
            return this._fetch(request);
        });
    }
    post(route_1, data_1) {
        return __awaiter(this, arguments, void 0, function* (route, data, isFullUrl = false, withCookies = true) {
            const options = {
                method: 'POST',
                mode: 'cors',
                headers: Object.assign(Object.assign({}, DEFAULT_HEADERS), { Accept: 'application/json', 'x-px-cookies': localStorage.getItem('pxcookie') || '' }),
                body: JSON.stringify(data),
            };
            if (withCookies) {
                options.credentials = 'include';
            }
            const url = isFullUrl ? new URL(route) : new URL(envConfig.OUTBOUND_SERVER_URL + route);
            const request = new Request(url.toString(), options);
            return this._fetch(request);
        });
    }
    delete(route_1) {
        return __awaiter(this, arguments, void 0, function* (route, isFullUrl = false) {
            const options = {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: Object.assign({}, DEFAULT_HEADERS),
            };
            const url = isFullUrl ? new URL(route) : new URL(envConfig.OUTBOUND_SERVER_URL + route);
            const request = new Request(url.toString(), options);
            return this._fetch(request);
        });
    }
    search(route, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: Object.assign(Object.assign({}, DEFAULT_HEADERS), { Accept: 'application/json', 'x-px-cookies': localStorage.getItem('pxcookie') || '' }),
                body: JSON.stringify(data),
            };
            const url = new URL(envConfig.OUTBOUND_SEARCH_URL + route);
            const request = new Request(url.toString(), options);
            return this._fetch(request);
        });
    }
    get(route_1) {
        return __awaiter(this, arguments, void 0, function* (route, isFullUrl = false) {
            const options = {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: Object.assign({}, DEFAULT_HEADERS),
            };
            const url = isFullUrl ? new URL(route) : new URL(envConfig.OUTBOUND_SERVER_URL + route);
            const request = new Request(url.toString(), options);
            return this._fetch(request);
        });
    }
    _fetch(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const fetchResult = yield fetch(request);
            let result;
            try {
                const responseText = yield (fetchResult === null || fetchResult === void 0 ? void 0 : fetchResult.text());
                // If response is empty or just whitespace, return empty object for successful requests
                if (fetchResult.ok && (!responseText || responseText.trim() === '')) {
                    return {};
                }
                // Try to parse as JSON
                result = JSON.parse(responseText);
            }
            catch (e) {
                if (fetchResult && !fetchResult.ok) {
                    throw fetchResult;
                }
                throw e;
            }
            if (fetchResult.ok) {
                return result;
            }
            throw new ApiError(result, fetchResult.status);
        });
    }
}
export default new AjaxUtils();
